module.exports = __webpack_public_path__ + "img/kalkulator.9fdc84df.svg";